<template>
  <div v-if="this.checkMobile()" class="grey-background-container">
    <MobileNavigationBack
      :moduleRoute="moduleRoute"
      :appbarTitle="appbarTitle"
    ></MobileNavigationBack>
    <div class="p-2">
      <br />
      <br />
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <!-- <jet-button @click="back"  class="bg-blue-500 rounded  text-white hover:bg-blue-500  hover:no-underline px-2 cursor-pointer  text-sm" >Back</jet-button>
         &nbsp; -->
      </div>

      <div class="max-w-7xl mx-auto mt-2">
        <div class="w-full">
          <div class="bg-white pb-8 mb-2">
            <!-- <div class="text-lg font-bold ">Create {{moduleName}}</div> -->

            <form @submit.prevent="update">
              <BsEdit
                :createDef="createDef"
                :routeDef="moduleRoute"
                :modelData="modelData"
                viewType="editview"
                ref="formRenderer"
              >
              </BsEdit>

              <div class="panel-footer mt-2 text-right">
                <jet-button
                  type="submit"
                  @click="update"
                  class="w-full text-center justify-center bg-yellow-500 hover:bg-yellow-500 cursor-pointer rounded text-sm pl-2 pr-2 pt-1 pb-1 text-white hover:no-underline"
                >
                  Update
                </jet-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <app-layout :title="title">
      <template v-slot:sidenav> </template>

      <template v-slot:horizonav>
        <nav-bar :scId="currentProduct" scType="product"> </nav-bar>
      </template>

      <div class="mt-3 mb-2">
        <jet-back-link class="max-w-7xl sm:px-6 lg:px-8">
          <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
          &nbsp; Go back
        </jet-back-link>
      </div>
      <PageTitle :headerTitle="title"> </PageTitle>

      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <p class="text-xs">{{ title }} record</p>
      </div>
      <form @submit.prevent="update">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <!-- <jet-button @click="back"  class="bg-blue-500 rounded  text-white hover:bg-blue-500  hover:no-underline px-2 cursor-pointer  text-sm">Back</jet-button> -->
          <div class="flex justify-start ...">
            <jet-button
              type="submit"
              class="bg-yellow-500 rounded text-white hover:bg-yellow-600 hover:no-underline px-2 cursor-pointer text-sm"
              >Update</jet-button
            >
            <jet-button
              @click="CreateAnother"
              class="bg-blue-500 rounded text-white hover:bg-blue-500 hover:no-underline px-2 cursor-pointer text-sm"
              >Save & Create Another</jet-button
            >
            <jet-button
              @click.prevent="back"
              @click="back"
              class="bg-gray-400 rounded text-white hover:bg-gray-400 hover:no-underline px-2 cursor-pointer text-sm"
              >Cancel</jet-button
            >
          </div>
          &nbsp;
        </div>

        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-2">
          <div class="w-full">
            <div class=" ">
              <!-- <div class="text-lg font-bold ">Create {{moduleName}}</div> -->

              <form @submit.prevent="update">
                <BsEdit
                  :createDef="createDef"
                  :slug="slug"
                  :routeDef="moduleRoute"
                  :modelData="modelData"
                  viewType="editview"
                  ref="formRenderer"
                >
                </BsEdit>

                <div class="panel-footer mt-2"></div>
              </form>
            </div>

            <div class="flex justify-start ...">
              <jet-button
                type="submit"
                class="bg-yellow-500 rounded text-white hover:bg-yellow-600 hover:no-underline px-2 cursor-pointer text-sm"
                >Update</jet-button
              >
              <jet-button
                @click="CreateAnother"
                class="bg-blue-500 rounded text-white hover:bg-blue-500 hover:no-underline px-2 cursor-pointer text-sm"
                >Save & Create Another</jet-button
              >
              <jet-button
                @click.prevent="back"
                @click="back"
                class="bg-gray-400 rounded text-white hover:bg-gray-400 hover:no-underline px-2 cursor-pointer text-sm"
                >Cancel</jet-button
              >
            </div>
          </div>
        </div>
      </form>
    </app-layout>
  </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetBackLink from "@/Jetstream/BackLink.vue";
import JetButton from "@/Jetstream/Button.vue";
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import MobileNavigationBack from "@/Layouts/MobileNavigationBack.vue";
import NavBar from "../../Layouts/NavBar.vue";

const modelData = {};

export default {
  props: {
    createDef: Array,
    moduleRoute: String,
    moduleName: String,
    moduleLabel: String,
    currentProduct: String,
    slug: String,
    modelData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    AppLayout,
    BsEdit,
    PageTitle,
    JetNavLink,
    JetButton,
    MobileNavigation,
    MobileNavigationBack,
    NavBar,
    JetBackLink,
  },
  data: function () {
    return {
      title: this.moduleLabel + " Edit",
      appbarTitle: this.moduleLabel + " Edit",
    };
  },
  methods: {
    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        console.log("CheckMobile Called: Mobile");
        return true;
      } else {
        console.log("CheckMobile Called: Desktop");
        return false;
      }
    },
    checkAction() {
      return this.modelData.hasOwnProperty("id") && this.modelData.id != "";
    },

update() {
  // Call grandchild method as in your original code
  this.$refs.formRenderer.callGrandchildMethod();
  
  const rawData = this.$refs.formRenderer.formData;
  
  // Check if we have files to upload
  const hasFiles = Object.values(rawData).some(
    value => value && typeof value === "object" && value.file instanceof File
  );
  //
  if (hasFiles) {
    // Use FormData approach for file uploads
    const formData = new FormData();
    
    // Add all form fields to the FormData
    for (const key in rawData) {
      const value = rawData[key];
      
      // Handle file uploads
      if (value && typeof value === "object" && value.file instanceof File) {
        formData.append(key, value.file);
      } 
      // Handle line items (convert objects to JSON strings)
      else if (key.includes('LineItem') && typeof value === 'object') {
        formData.append(key, JSON.stringify(value));
      } 
      // Handle all other fields
      else {
        formData.append(key, value);
      }
    }
    
    // For updates, we need to indicate this is a PUT request since FormData only supports POST
    formData.append('_method', 'PUT');
    
    // Use Inertia with FormData (using post with _method: PUT for file uploads)
    this.$inertia.post(
      route(this.moduleRoute + ".update", [this.slug, this.modelData.id]),
      formData,
      {
        preserveScroll: true,
        forceFormData: true,
        onSuccess: () => {
          this.showToast("Successfully updated", "success");
        },
        onError: (errors) => {
          console.error("Update errors:", errors);
        },
      }
    );
  } else {
    // If no files, use the regular JSON approach with PUT
    const formData = { ...rawData };
    
    // Use Inertia's put method directly
    this.$inertia.put(
      route(this.moduleRoute + ".update", [this.slug, this.modelData.id]),
      formData,
      {
        preserveScroll: true,
        onSuccess: () => {
          this.showToast("Successfully updated", "success");
        },
        onError: (errors) => {
          console.error("Update errors:", errors);
        },
      }
    );
  }
},
    back() {
      this.$inertia.get(
        route(this.moduleRoute + ".show", [this.slug, this.modelData.id])
      );
    },
  },
  mounted() {
    this.checkMobile();

    // console.log('/'+this.moduleRoute)
  },
};
</script>

<style>
.grey-background-container {
  background-color: #ffffff;
  height: 100vh;
}
/* p{
margin-bottom: .4rem;
} */
.createName {
  background-color: white !important;
  margin-top: 10px;
  padding: 10px 30px;
}
.dx-form-group-caption {
  font-size: 14px;
  font-weight: bold;
  color: #535252;
}
.dx-field-item-label-text {
  color: #838282;
}
</style>